<footer class="footer">
  <div class="footer__main">
    <!-- the name, as wide as the footer, in outline like the cities of the franchise section: it lies behind the links -->
    <p class="container footer__name" aria-hidden="true"><span>Little Nap</span></p>

    <div class="container footer__top">
      <div class="footer__brand">
        <a class="footer__logo" href="#top" aria-label="Little Nap Recliners — back to top">
          <img src="assets/logo.png" alt="Little Nap Recliners — Joy of Comfort" width="790" height="481" loading="lazy" />
        </a>
        <p class="footer__tag">An Indian brand with global acclaim — world-class recliners for homes, home theatres, cinemas, hospitals and club houses.</p>
        <ul class="footer__phones">
          <li>
            <span>Need help? Call now</span>
            <a [href]="phone.href">{{ phone.label }}</a>
          </li>
          <li>
            <span>Tamil Nadu</span>
            <a [href]="phoneTn.href">{{ phoneTn.label }}</a>
          </li>
        </ul>
      </div>

      @for (col of columns; track col.title) {
        <nav class="footer__col" [attr.aria-label]="col.title">
          <h2 class="footer__title">{{ col.title }}</h2>
          <ul>
            @for (link of col.links; track link.label) {
              <li><a [href]="link.href" target="_blank" rel="noopener">{{ link.label }}</a></li>
            }
          </ul>
        </nav>
      }
    </div>
  </div>

  <div class="container footer__bottom">
    <p class="footer__copy">© 2011–2026 Little Nap Recliners. All rights reserved.</p>
    <p class="footer__also">
      Also available on
      @for (m of marketplaces; track m) {
        <span>{{ m }}</span>
      }
    </p>
  </div>
</footer>
